<template>
  <div class="file-view">
    <mt-header fixed title="查看报告">
      <router-link to="/tdShared/tdOrderDetail" slot="left">
        <mt-button icon="back"></mt-button>
      </router-link>
    </mt-header>
    <img v-for="(item,index) in imageList" :key="index" :src="item" width="100%">
  </div>
</template>

<script>
import UserOrderInfoService from "../../_services/user.order.info.service";
import UserOrderInfoTestTypeOrderService from "../../_services/userOrderInfoTestTypeOrder.service";
export default {
  name: "TianDingFileViewComponent",
  data() {
    return {
      params: {},
      imageList: []
    };
  },
  mounted() {
    this.params = this.$route.query;
    this.indicator$.open("请稍后...");
    if (this.params.ItemTypeID !== undefined) {
      UserOrderInfoService.GetOrderDetailModelByOrderID(this.params).then(
        response => {
          let item = response.Data.find(
            e => e.ItemTypeID == this.params.ItemTypeID
          );
          this.getImageList(item.ReportUrl).then();
        }
      );
    } else {
      UserOrderInfoTestTypeOrderService.downloadReportByOrder(this.params).then(
        response => {
          this.getImageList(response).then();
        }
      );
    }
  },
  methods: {
    async getImageList(response) {
      let pdf = await this.utils$.pdfConvertImage(response);

      let pages = pdf.numPages;

      for (let i = 1; i <= pages; i++) {
        let canvas = document.createElement("canvas");
        let page = await pdf.getPage(i);
        let scale = 1;
        let viewport = page.getViewport(scale);
        let context = canvas.getContext("2d");

        canvas.height = viewport.height;
        canvas.width = viewport.width;

        let renderContext = {
          canvasContext: context,
          viewport: viewport
        };

        await page.render(renderContext);

        this.imageList.push(canvas.toDataURL("image/png"));

        this.indicator$.close();
      }
    }
  }
};
</script>

<style lang="scss">
</style>





// WEBPACK FOOTER //
// src/views/others/fileView.vue